import React, {useRef, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import ListItemIcon from "@mui/material/ListItemIcon";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import {setWizardActiveItem} from "../../../actions/wizardFunctions";
import {useOutsideClick} from "../../../misc/helperHooks";
import Analytics, {QKB_ANALYTIC_EVENTS} from "../../../analytics";
import {switchToWizardItem} from "./useChangeWizardStepRoute";
import {getCurrentWizardList} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";


const MaterialsWizardFooterDropDown = (props) => {

  const {wizardActiveItem, wizardList, windowWidth, isMobile, activePreset} = props;
  const [opened, setOpened] = useState(false);

  const dropdownElement = useRef();

  const renderWizardList = getCurrentWizardList(wizardList, activePreset);

  const handleToggleDropdown = () => {
    setOpened(!opened);
  }

  useOutsideClick(dropdownElement, () => {
    if (opened) {
      handleToggleDropdown();
    }
  });

  const wizardItemClick = (wizardItem) => {
    console.log("wizardItem", wizardItem);
    Analytics.sendClickEvent(QKB_ANALYTIC_EVENTS.quotingToolWizardSwitch + wizardItem.id);
    if (wizardItem.id !== wizardActiveItem.id) {
      switchToWizardItem(wizardItem);
    }
    handleToggleDropdown();
  }

  const dropDownStyles = opened ? { height:window.innerHeight - 60 } : {};
  if (opened) {
    dropDownStyles.height = (!isMobile && window.innerHeight > 320) ? 320 : window.innerHeight - 60
  }

  return (
    <div className="selection-footer-buttons__select" ref={dropdownElement}>
      <div className={"ui-select2" + (opened ? " ui-select2--opened" : "")}>
        <div className={"ui-select2__input"} onClick={handleToggleDropdown}>
          {isMobile && (windowWidth < 768) ? null : (
            <span className={"ui-select2__input-label"}>
              <FormattedMessage id="quotingTool.footer.selectDropdownSortBy"/>
            </span>
          )}
          <span className={"ui-select2__input-value"}>
            {wizardActiveItem.name}
          </span>
        </div>
        <div className={"ui-select2__dropdown"} style={dropDownStyles}>
          <ul className={"ui-select2__dropdown-list"}>
            {renderWizardList.map((wizardItem) => {
              const isActive = wizardItem.id === wizardActiveItem.id;
              const {customImageUrl, uploadedImageUrl} = wizardItem;
              const bgImageUrl = customImageUrl || uploadedImageUrl
              // if (isActive) {
              //   bgImageUrl = qtCategory.bgImageUrl.split(".svg")[0] + "-white.svg"
              // }
              return (
                <li key={"dropdown"+wizardItem.id}
                    onClick={() => wizardItemClick(wizardItem)}
                    style={{
                      backgroundImage: `url(${bgImageUrl})`,
                    }}
                    className={"ui-select2__dropdown-list-item ui-select2__dropdown-list-item--wizard"
                      + (!bgImageUrl ? " ui-select2__dropdown-list-item--wizard--no-icon" : "")
                      + (isActive ? " ui-select2__dropdown-list-item--active" : "")}>
                  {!bgImageUrl ? (
                    <ListItemIcon>
                      <AutoFixHighIcon/>
                    </ListItemIcon>
                  ) : null}
                  <span className="ui-select2__dropdown-list-item-name">{wizardItem.name}</span>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )

};

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem} = store.wizardState;
  const {isMobile, windowWidth} = store.serverState;
  const {activePreset} = store.serverState;

  return {
    wizardList,
    wizardActiveItem,
    windowWidth,
    isMobile,
    activePreset,
  };
};

const mapDispatchToProps = {
  setWizardActiveItem
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsWizardFooterDropDown)
